import * as React from "react";
import "./send_mail.scss";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { makeStyles } from "@mui/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { grey } from "@mui/material/colors";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { ApiUrl } from "../../env";
import { Link } from "react-router-dom";
import axios from "axios";
import { deepOrange } from "@mui/material/colors";
import { useSelector, useDispatch } from "react-redux";
import { setEmailShow, setEmailHide } from "../../store/emailSelector";
import EmailBody from "./email_body.js";

const DialogCont = styled(DialogContent)(({ theme }) => ({
  backgroundColor: theme.color.main,
  padding: theme.spacing(1),
  textAlign: "center",
  alignItems: "center",
  justifyContent: "center",
  color: theme.color.secondary,
}));

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme }) => ({
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
  variants: [
    {
      props: ({ expand }) => !expand,
      style: {
        transform: "rotate(0deg)",
      },
    },
    {
      props: ({ expand }) => !!expand,
      style: {
        transform: "rotate(180deg)",
      },
    },
  ],
}));

const L = styled(Link)(({ theme }) => ({
  color: deepOrange[400],
  fontSize: "1.2rem",
  fontFamily: "Roboto",
}));

export default function MailDialogs() {
  const dispatch = useDispatch();
  //   const [open, setOpen] = useState(false);
  const emailShow = useSelector((state) => state.emailSelector.email);
  const handleClose = () => {
    dispatch(setEmailHide());
  };

  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  //   useEffect(() => {
  //     setOpen(open_);
  //   }, [open_]);

  return (
    <Dialog
      sx={{
        "& .MuiPaper-root": {
          width: "100%", // Растягиваем на всю ширину
          maxWidth: "600px", // Ограничиваем сверху, чтобы не было слишком широкого контента
          margin: 0,
          padding: 0,
          overflow: "hidden",
        },
      }}
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      // open={emailShow}
      open={true}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        Письмо {emailShow[0]}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogCont dividers>
        <EmailBody send_email={emailShow[1]} />
      </DialogCont>
    </Dialog>
  );
}
